import { ReactElement, use } from 'react';

import WanderingBoundaryPassageRowProviderContext from 'features/wandering-boundary-settings/providers/contexts/wandering-boundary-passage-row-provider-context';
import WanderingBoundaryPassageRowCreateEdit from 'features/wandering-boundary-settings/views/wandering-boundary-passage-row/wandering-boundary-passage-row-create-edit.component';
import WanderingBoundaryPassageRowViewing from 'features/wandering-boundary-settings/views/wandering-boundary-passage-row/wandering-boundary-passage-row-viewing.component';

const WanderingBoundaryPassageRow = (): ReactElement => {
  const { viewingMode } = use(WanderingBoundaryPassageRowProviderContext);

  switch (viewingMode) {
    case 'creation':
    case 'editing':
      return <WanderingBoundaryPassageRowCreateEdit />;
    case 'viewing':
      return <WanderingBoundaryPassageRowViewing />;
    default:
      return <></>;
  }
};

export default WanderingBoundaryPassageRow;
